import React from 'react';

const LOGO_SRC = '/logo-ionic-lockup-v3.png';

/**
 * Ionic Estate Sales horizontal lockup. Displayed as delivered (solid
 * black background, green house mark, white "IONIC / ESTATE SALES"
 * wordmark) with softly rounded corners so the black plaque reads as a
 * finished badge rather than a raw rectangle.
 */
export const LogoLockup = ({ dark = true, size = 'md' }) => {
  // eslint-disable-next-line no-unused-vars
  const _dark = dark;
  const heights = {
    sm: 'h-11',   // 44px
    md: 'h-14',   // 56px
    lg: 'h-16',   // 64px
    xl: 'h-20',   // 80px
  };
  const heightClass = heights[size] || heights.md;

  return (
    <img
      src={LOGO_SRC}
      alt="Ionic Estate Sales"
      className={`${heightClass} w-auto object-contain select-none rounded-lg`}
      draggable={false}
    />
  );
};

export const LogoMark = LogoLockup;
export default LogoLockup;
